module.exports = __webpack_public_path__ + "/images/ico-color-hand-heart.aff648e.svg";